import { FC, Fragment } from 'react';
import { ModalProps } from '../../atoms/Modal';
import { TimetableItemProps } from '../../atoms/TimetableItem';
import { DateTime } from 'luxon';
import Modal from '../../atoms/Modal/Modal';
import { Location } from '../../icons';
import {
  StyledEventInfoColorSwatch,
  StyledEventInfoDate,
  StyledEventInfoHeading,
  StyledEventInfoType,
  StyledEventInfoLocation,
  StyledEventInfoMisc,
  StyledEventInfoModuleList,
} from './TimetableEventInfo.styles';
import { ModalContent } from '../../atoms/Modal/Modal.styles';

export interface TimetableEventInfoProps extends Omit<ModalProps, 'children'> {
  /** the event(s) to show information about */
  events: TimetableItemProps[];
}

/**
 * Designed to be used by the Timetable component, shows a modal dialog with
 * information about the provided event
 */
export const TimetableEventInfo: FC<TimetableEventInfoProps> = ({
  open,
  onClose,
  events,
}) => {
  return (
    <Modal
      data-testid="event-info-modal"
      open={open}
      onClose={onClose}
      closeButtonInsideModal={false}
      style={{
        border: 0,
        background: 'transparent',
        boxShadow: 'none',
      }}
    >
      <br />
      {events.map((event) => {
        const start = DateTime.fromISO(event.start);
        const end = DateTime.fromISO(event.end);
        return (
          <ModalContent key={event.id} style={{ marginBottom: 32 }}>
            <StyledEventInfoType>
              <StyledEventInfoColorSwatch $color={event.color} />
              {event.eventDetails.type}
            </StyledEventInfoType>
            <StyledEventInfoHeading>
              {event.eventDetails.moduleNames.length > 1
                ? `${event.eventDetails.moduleNames.length} Modules:`
                : event.eventDetails.moduleNames[0]}
            </StyledEventInfoHeading>
            {event.eventDetails.moduleNames.length > 1 && (
              <StyledEventInfoModuleList>
                {event.eventDetails.moduleNames.map((moduleName, i) => (
                  <li key={i}>{moduleName}</li>
                ))}
              </StyledEventInfoModuleList>
            )}
            <StyledEventInfoDate>
              {start.toFormat('EEEE d MMMM ⋅ HH:mm - ')}
              {end.toFormat('HH:mm')}
            </StyledEventInfoDate>
            {!!event.eventDetails.moduleGroups.length && (
              <StyledEventInfoMisc>
                Module Group{event.eventDetails.moduleGroups.length > 1 && 's'}:{' '}
                {event.eventDetails.moduleGroups.join(', ')}
              </StyledEventInfoMisc>
            )}
            {!!event.eventDetails.lecturerNames.length && (
              <StyledEventInfoMisc>
                Lecturer{event.eventDetails.lecturerNames.length > 1 && 's'}:{' '}
                {event.eventDetails.lecturerNames
                  .map((str) =>
                    str.replace(/(.*),(.*)/g, (_, $1, $2) => `${$2} ${$1}`),
                  )
                  .join(', ')}
              </StyledEventInfoMisc>
            )}
            {event.eventDetails.roomNames.map((roomName, i) => (
              <StyledEventInfoLocation key={i}>
                <Location />
                {roomName}
              </StyledEventInfoLocation>
            ))}
          </ModalContent>
        );
      })}
    </Modal>
  );
};

export default TimetableEventInfo;
